import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { BaseModule } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { FormFieldModule } from '@sb/library/form-field';
import { IconModule } from '@sb/library/icon';
import { ListGroupComponent } from './group/list-group.component';
import { ListItemRowComponent } from './item-row/list-item-row.component';
import { ListComponent } from './list.component';

@NgModule({
    declarations: [
        ListComponent,
        ListItemRowComponent,
        ListGroupComponent
    ],
    imports: [
        CommonModule,
        MatListModule,
        MatExpansionModule,
        FormFieldModule,
        IconModule,
        ButtonModule,
        BaseModule
    ],
    exports: [
        ListComponent,
        ListItemRowComponent,
        ListGroupComponent
    ]
})
export class ListModule { }
